import { render, staticRenderFns } from "./DateQuestion.vue?vue&type=template&id=1d8dfda8&"
import script from "./DateQuestion.vue?vue&type=script&lang=js&"
export * from "./DateQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports